<template>
    <div>

        <!-- MODAL WINDOW -->
        <modal
            width="460"
            :title="$t(modalTitle)"
            transition="fadeDown"
            cancel-text="Abbrechen"
            :show-ok="false"
            :backdrop-closable="false"
            :is-show="showModal"
            @close="closeModal">

            <div class="has-text-centered">

                <template v-if="progressStatus != null">

                    <template v-if="progressStatus != null && progressStatus.status != 'Finished'">

                        <template v-if="progressStatus.status == 'Error'">

                            <div class="has-text-centered" style="margin-bottom: 5px;">
                                PROBLEM ...:<br />
                                <span style="color: red; ">{{ progressStatus.log }}</span>
                            </div>

                        </template>

                        <template v-else>

                            <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                            <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                        </template>

                    </template>

                    <template v-else-if="progressStatus != null && progressStatus.status == 'Finished'">

                        <a :href="taskDownloadLink" download class="button is-success" @click.stop="closeModal">
                            <span class="icon is-small"><i class="fa fa-download"></i></span>
                            &nbsp;<span>DOWNLOAD</span>
                        </a>

                    </template>

                    <template v-else>

                        <div class="has-text-centered">

                        </div>

                    </template>


                </template>


                <template v-else>

                    <template v-if="downloadLink == '' && modalErrorMsg == false">
                        <loading-indicator-small></loading-indicator-small>
                    </template>

                    <template v-else class="has-text-centered">

                        <template v-if="modalErrorMsg == false">
                            <a :href="downloadLink" download class="button is-success" @click.stop="closeModal">
                                <span class="icon is-small"><i class="fa fa-download"></i></span>
                                &nbsp;<span>DOWNLOAD</span>
                            </a>
                        </template>

                        <template v-else>
                            {{ modalErrorMsg }}
                        </template>

                    </template>

                </template>

            </div>

        </modal>

        <custom-button type="dark" :size="btnSize" :name="btnTitle" icon="icon-ak-export" @click.native="doExport()" :class="{ 'is-disabled': isDisabled }"></custom-button>

    </div>

</template>


<script>

export default {

    props: {
        exportType: {
            type: String,
            default: ''
        },
        exportUrl: {
            type: String,
            default: ''
        },
        modalTitle: {
            type: String,
            default: 'EXPORT'
        },
        btnTitle: {
            type: String,
            default: 'EXPORT'
        },
        btnSize: {
            type: String,
            default: 'isLarge'
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            showModal: false,
            downloadLink: '',
            modalErrorMsg: false,
            progressStatus: null,
            refreshIntervalId: null,
        }
    },

    created() {

    },

    computed: {

        taskDownloadLink() {
            return this.$config.cdnHost + this.progressStatus.log;
        }

    },

    methods: {

        closeModal() {

            if(this.refreshIntervalId != null) {
                clearInterval(this.refreshIntervalId);
            }
            this.progressStatus = null;
            this.showModal=false

        },

        doExport() {

            this.showModal = true;
            this.downloadLink = "";

            let self = this;

            if (this.exportUrl != '') {

				this.entityGet(this.exportUrl)
					.then(function(res) {

                        // we've to deal with a task
                        if(typeof res.taskLogId != 'undefined') {

                            var taskLogId = res.taskLogId;

                            self.refreshIntervalId = setInterval(function() {

                                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                                    .then(function(response) {

                                        self.progressStatus = response.data;

                                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {
                                            clearInterval(self.refreshIntervalId);
                                        }

                                    });

                            }.bind(self), 500);


                        // common download link
                        } else {

                            if(self.exportType == 'successControl') {

                                self.downloadLink = self.$config.assets + 'sitePerformanceDocument/' + res.site.filename;

                            } else if(self.exportType == 'articleVariant') {

                                self.downloadLink = self.$config.assets + res.articleVariant.dir + '/' + res.articleVariant.filename;

                            } else {

                                self.downloadLink = self.$config.cdnHost + res.url;

                            }

                        }

                    }).catch(function(error) {

                        self.modalErrorMsg = "Beim Erstellen des Downloadlinks trat ein Fehler auf: " + error;

                    });

			} else {

                this.modalErrorMsg = "Dieser Export existiert nicht!";

            }

        }

    }
}

</script>
